export const MODIFIER_IMAGE_DISPLAY_TYPES = {
  INLINE: "inline",
  BLEED: "bleed",
};
